const INITIAL_STATE = {
  addExamDialog: false,
  addFolderDialog: false,
  renameExamDialog: false,
  renameFolderDialog: false,
  copyExamDialog: false,
  moveExamDialog: false,
  examExistsDialog: false,
  moveFolderDialog: false,
  folderExistsDialog: false,
  printExamDialog: false,
  deleteExamDialog: false,
  deleteFolderDialog: false,
  discardChangesExamDialog: false,
  selectTopicsExamDialog: false,
  selectExercisesExamDialog: false,
  noObjectiveSelectedDialog: false,
  createPdfDialog: false,
  changeLayoutDialog: false,

  targetPath: "",

  indexStepCreatePdf: 0,
};

export const DIALOG_TYPES = {
  OPEN_DIALOG: "openDialog",
  CLOSE_DIALOG: "closeDialog",

  SET_TARGET_PATH: "setTargetPath",

  SET_INDEX_STEP_CREATE_PDF: "setIndexStepCreatePdf",
};

export const DIALOGS = {
  ADD_EXAM_DIALOG: "addExamDialog",
  ADD_FOLDER_DIALOG: "addFolderDialog",
  RENAME_EXAM_DIALOG: "renameExamDialog",
  RENAME_FOLDER_DIALOG: "renameFolderDialog",
  COPY_EXAM_DIALOG: "copyExamDialog",
  MOVE_EXAM_DIALOG: "moveExamDialog",
  EXAM_EXISTS_DIALOG: "examExistsDialog",
  MOVE_FOLDER_DIALOG: "moveFolderDialog",
  FOLDER_EXISTS_DIALOG: "folderExistsDialog",
  PRINT_EXAM_DIALOG: "printExamDialog",
  DELETE_EXAM_DIALOG: "deleteExamDialog",
  DELETE_FOLDER_DIALOG: "deleteFolderDialog",
  DISCARD_CHANGES_EXAM_DIALOG: "discardChangesExamDialog",
  SELECT_TOPICS_EXAM_DIALOG: "selectTopicsExamDialog",
  SELECT_EXERCISES_EXAM_DIALOG: "selectExercisesExamDialog",
  NO_OBJECTIVE_SELECTED_DIALOG: "noObjectiveSelectedDialog",
  CREATE_PDF_DIALOG: "createPdfDialog",
  CHANGE_LAYOUT_DIALOG: "changeLayoutDialog",

  TARGET_PATH: "targetPath",
};

function dialogReducer(
  state = INITIAL_STATE,
  action: { type: string; payload: { dialogName?: string; targetPath?: string; index?: number } }
) {
  switch (action.type) {
    case DIALOG_TYPES.OPEN_DIALOG:
      return { ...state, [action.payload.dialogName!]: true };

    case DIALOG_TYPES.CLOSE_DIALOG:
      return { ...state, [action.payload.dialogName!]: false };

    case DIALOG_TYPES.SET_TARGET_PATH:
      return { ...state, targetPath: action.payload.targetPath };

    default:
      return state;
  }
}

export default dialogReducer;
